import { html_beautify } from 'js-beautify';

/** Pretty-print HTML. Returns input unchanged if beautify throws. */
export function formatHtml(src: string): string {
  try {
    return html_beautify(src, {
      indent_size: 2,
      wrap_line_length: 0,
      preserve_newlines: true,
      max_preserve_newlines: 1,
      end_with_newline: false,
    });
  } catch {
    return src;
  }
}
